import { render, staticRenderFns } from "./JobBudgets.vue?vue&type=template&id=a08ed2b4"
import script from "./JobBudgets.vue?vue&type=script&lang=js"
export * from "./JobBudgets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports